import {ACTION_CODE} from './_actionCode';
import {SeniorityService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_SENIORITY';

export async function createSeniority(userData: Record<string, any>, seniority: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createSeniority - Start');

        const createSeniorityResult = await SeniorityService.createSeniority(userData, seniority);

        LoggerService.logInfo('Action - createSeniority - End - Success');

        return ResultModel.newSuccessResult(createSeniorityResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createSeniority - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
